import React from "react";
import Snackbar from "@mui/material/Snackbar";
import { AlertSuccess } from "common/styles/muiStyled";

type Props = {
  show: boolean;
  message: string;
  hide: () => void;
};

const CustomSnackbar: React.FC<Props> = ({show, message, hide}) => {
  const handleClose = (_: React.SyntheticEvent | React.MouseEvent, reason?: string) => {
    if (reason === "clickaway") {
      return;
    }

    hide();
  };

  return (
    <Snackbar
      open={show}
      autoHideDuration={6000}
      data-testid="snackbar"
      onClose={handleClose as any}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <AlertSuccess elevation={6} onClose={handleClose}>
        {message}
      </AlertSuccess>
    </Snackbar>
  );
};

export default CustomSnackbar;
